import React from 'react';
import BooleanRadioButtons from '../components/BooleanRadioButtons';
import Card from '../components/card';
import { BorrowerCard, CoborrowerCard } from './card-lenses';

const OwnsPrimaryResidence = ({ model, onChange, ...cardProps }) => (
  <Card {...cardProps}>
    <BooleanRadioButtons
      name="ownsPrimaryResidence"
      value={model.get('ownsPrimaryResidence')}
      onChange={onChange.bind(null, 'ownsPrimaryResidence')}
      trueLabel="Own"
      falseLabel="Rent"
    />
  </Card>
);

OwnsPrimaryResidence.completed = ({ model }) => model.get('ownsPrimaryResidence') != null;

const BorrowerOwnsPrimaryResidence = BorrowerCard(
  OwnsPrimaryResidence,
  'BorrowerOwnsPrimaryResidence',
  {
    title: 'Do you own or rent your current primary residence?'
  }
);

const CoborrowerOwnsPrimaryResidence = CoborrowerCard(
  OwnsPrimaryResidence,
  'CoborrowerOwnsPrimaryResidence',
  {
    title: 'Does your co-borrower own or rent their current primary residence?'
  }
);

export { BorrowerOwnsPrimaryResidence, CoborrowerOwnsPrimaryResidence };



// WEBPACK FOOTER //
// ./src/cards/owns-primary-residence.js